import { useEffect, useState } from "react";
import { Button, Container, Form, Modal } from "react-bootstrap"
import { IoHomeOutline } from "react-icons/io5"
import { AllUsers, GetAllManagerUsers } from "../../utils/proxy/Authproxy";
import Select from "react-select";
import { Op_per } from "../../utils/Permissions";
import DataTable from "react-data-table-component";
import LoadingComponent from "../Includes/LoadingComponent";
import { GetMonthlyAreaProductSummaryForUser } from "../../utils/proxy/ChartsProxy";
import { Parser } from "@json2csv/plainjs";
import { RiFileExcel2Fill } from "react-icons/ri";
import Swal from "sweetalert2";
import Helper from "../../utils/helperFunctions";

const MonthlyProductSummaryReport = () => {


const months = {
        '01':'Jan',
        '02':'Feb',
        '03':'Mar',
        '04':'Apr',
        '05':'May',
        '06':'Jun',
        '07':'Jul',
        '08':'Aug',
        '09':'Sep',
        '10':'Oct',
        '11':'Nov',
        '12':'Dec',

    }

    const [data, setData] = useState([]);
    const [userid, setUserId] = useState(localStorage.getItem('role') === 'User' ? localStorage.getItem('uuid') : null);
    const [selectedUser, setSelectedUser] = useState();
    const [selectedType, setSelectedType] = useState({ value: 'doctor', label: 'Doctor' });
    const [users, setUsers] = useState([]);
    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [reload, setReload] = useState(false);
    const [pending, setPending] = useState(false);
    const [filterText, setFilterText] = useState("");

    useEffect(() => {
        // Fetch data from an API when the component mounts
        const getallusers = async () => {
            if (localStorage.getItem('role') === 'Admin') {
                let allusers = await AllUsers();
                allusers.push({ firstname: localStorage.getItem('firstname'), lastname: localStorage.getItem('lastname'), userid: localStorage.getItem('uuid'), username: localStorage.getItem('username') })
                setUsers(allusers);
            } else if (localStorage.getItem('role') === 'Manager') {
                let allusers = await GetAllManagerUsers(localStorage.getItem('uuid'));
                setUsers(allusers);
            }
        };
        getallusers();
    }, []);

    useEffect(() => {
        // Fetch data from an API when the component mounts
        const getallteritories = async (userid, from, to, type) => {
            let userteritories = await GetMonthlyAreaProductSummaryForUser(
                userid,
                from,
                to,
            );

            if (userteritories) {
                setData(userteritories);
                setPending(false);
            } else {
                alert("Error", "Issue While Fetching Tour Plan");
            }
        };
        if (userid && start && end) {
            setPending(true);
            getallteritories(userid, start, end);
        }
        setReload(false);
    }, [reload, userid, start, end]);

    const handleSelectChange = (selected) => {

        setUserId(selected.value);
        setSelectedUser(selected);
    };

    const handleStartMonth = (value) => {
        setStart(value);
    }              


        const options = [];
        users.map((user) => {
        options.push({
            value: user.userid,
            label: user.username + "(" + user.firstname + " " + user.lastname + ")",
            name: user.username
        });
    });

    async function downloadCSV(salesData) {


      if (!selectedUser) {
    Swal.fire({
      title: 'Validation Error',
      text: 'Please select a user.',
      icon: 'warning'
    });
    return;
  }

  if (!start) {
    Swal.fire({
      title: 'Validation Error',
      text: 'Please select the start month.',
      icon: 'warning'
    });
    return;
  }

  if (!end) {
    Swal.fire({
      title: 'Validation Error',
      text: 'Please select the end month.',
      icon: 'warning'
    });
    return;
  }

  if (end < start) {
    Swal.fire({
      title: 'Validation Error',
      text: 'End month cannot be earlier than start month.',
      icon: 'warning'
    });
    return;
  }

  if (!selectedType) {
    Swal.fire({
      title: 'Validation Error',
      text: 'Please select a type.',
      icon: 'warning'
    });
    return;
  }

  if (!salesData || !Array.isArray(salesData) || salesData.length === 0) {
    alert("No sales data available to export.");
    return;
  }

const escapeCSV = (cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`;

  const rows = [];

  // Push header row
  rows.push(["Month", "Area", "Product Name", "Quantity"]);

  salesData.forEach(monthEntry => {
    const month = monthEntry.month;
    const productDetails = monthEntry.productDetails;

    if (productDetails && productDetails.length > 0) {
      productDetails.forEach(detail => {
        // Skip dummy data
        if (
          detail.productName === "0" &&
          detail.area === "0" &&
          detail.totalQunatity === 0
        ) {
          return;
        }

        rows.push([
          month,
          detail.area.trim(),
          detail.productName,
          detail.totalQunatity
        ]);
      });
    }
  });

  // Convert rows to CSV string
  const csv = rows
    .map(row =>
      row
        .map(field => {
          if (field == null) return "";
          const fieldStr = field.toString();
          if (/[",\n]/.test(fieldStr)) {
            return `"${fieldStr.replace(/"/g, '""')}"`;
          }
          return fieldStr;
        })
        .join(",")
    )
    .join("\n");

  // Create downloadable link
    // Convert to CSV string
  const csvContent = rows.map(row => row.map(escapeCSV).join(",")).join("\n");
   // Add optional header/title before CSV content
  const csvHeaderText = `ProductSummaryReport-[${selectedUser.name}] ${start} to ${end}\n\n`;
  const finalCSV = "\uFEFF" + csvHeaderText + csvContent;

  // Create blob and trigger download
  const blob = new Blob([finalCSV], { type: "text/csv;charset=utf-8;" });
  const filename = `ProductSummaryReport[${selectedUser.name}]-${start}to${end}.csv`;

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



const columns = [
  {
    name: "Month",
    selector: (row) => row.month,
    sortable: false,
    cell: row => {
      if (row.month === null || row.month === "") {
        return ""; // subsequent rows: show empty
      }
      return row.month || "" // first row: show value or n/a
    }
  },
  {
    name: "Product Name",
    selector: (row) => row.productName,
    sortable: false,
  },
  {
    name: "Area",
    selector: (row) => row.area,
    sortable: false,
  },
  {
    name: "Total Quantity",
    selector: (row) => row.totalQuantity,
    sortable: true,
    right: false,
  },
];

const filteredData = data.flatMap(monthData =>
  monthData.productDetails.map((product, index) => {
    const row = {
      month: monthData.month,
      productName: product.productName,
      area: product.area,
      totalQuantity: product.totalQunatity,
      _month: monthData.month // Keep original month for filtering
    };

    return row;
  })
).filter(row =>
  row.productName?.toLowerCase().includes(filterText.toLowerCase()) ||
  row.area?.toLowerCase().includes(filterText.toLowerCase()) ||
  row._month?.toLowerCase().includes(filterText.toLowerCase())
);


  return (
 <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                    backgroundColor: 'transparent'
                }}
            >

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ul id="breadcrumb">
                        <li><a href="/"><IoHomeOutline
                            style={{ color: "white", fontSize: 20 }}
                        /></a></li>
                        <li><a href="/visit-analysis"><span class="icon icon-beaker"> </span>Reports</a></li>

                        <li><a href="#"><span class="icon icon-double-angle-right"></span>Product Summary Report</a></li>

                    </ul>

                </div>

            </div>
            <div className="glass-body" style={{ margin: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                    }}
                    className="flex-column-mobile"
                >
                    <div style={{ width: "250px", display: Op_per.get().REPORTS_TP_VS_ACHIEVEMENT.USER_DROPDOWN ? '' : 'none' }}>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <Form.Label className="mt-2">Users</Form.Label>
                            <div className="w-75">
                                <Select
                                    className="selectdoctor"
                                    options={options}
                                    value={selectedUser}
                                    onChange={handleSelectChange}
                                    styles={{

                                        dropdownIndicator: (provided) => ({
                                            ...provided,
                                            color: '#ccc' // Change color of the arrow here
                                        })
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div style={{ width: "250px" }}>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <Form.Label className="mt-2">From</Form.Label>
                            <div className="w-75">
                                <input className="selectdoctor" type="month" id="start" name="start" onChange={(e) => handleStartMonth(e.target.value)} value={start} />
                            </div>
                        </Form.Group>
                    </div>
                    <div style={{ width: "250px" }}>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <Form.Label className="mt-2">To</Form.Label>
                            <div className="w-75">
                                <input className="selectdoctor" type="month" id="start" name="end" onChange={(e) => setEnd(e.target.value)} value={end} />
                            </div>
                        </Form.Group>
                    </div>
                    <div style={{ width: "250px" }}>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <Form.Label className="mt-2">Search</Form.Label>
                            <div className="w-75">
                                  <Form.Control
                                    type="text"
                                    placeholder="Search by product, area or month"
                                    value={filterText}
                                    onChange={(e) => setFilterText(e.target.value)}
                                />
                            </div>
                        </Form.Group>
                    </div>
                     <div style={{marginLeft:"20px"}}  onClick={() => downloadCSV(data)}><Button ><RiFileExcel2Fill /></Button></div>
                </div>


                {pending ? (<div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}><LoadingComponent /></div>) : (<div style={{ justifyContent: 'center', alignItems: 'center' }}>
                    
<DataTable
  columns={columns}
  data={filteredData}
  progressPending={pending}
  pagination
  highlightOnHover
  dense
  noDataComponent="No data available for selected range"
/>
                </div>)
}
                </div>
                </Container>
  )
}

export default MonthlyProductSummaryReport
